import { render, staticRenderFns } from "./table-receiver-summary.vue?vue&type=template&id=fc82c004&scoped=true&"
import script from "./table-receiver-summary.vue?vue&type=script&lang=js&"
export * from "./table-receiver-summary.vue?vue&type=script&lang=js&"
import style0 from "./table-receiver-summary.vue?vue&type=style&index=0&id=fc82c004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc82c004",
  null
  
)

export default component.exports